<template>
  <div>
    <Hero
      image="banner-sobre-vaga.png"
      layout="half"
      title="<strong>Validando Teste...</strong>"
    />

    <div class="row pb-5 mt-5">
      <div class="col-10 col-lg-8 mx-auto">
        <div class="bg-white shadow-sm p-5">
          <h4 class="m-3 text-muted font-weight-normal">
            {{ username }}, <br />
            estamos validando seu teste, aguarde só mais um momento...
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
export default {
  name: "ReturnTest",
  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    username() {
      return this.$store.state.user.profile.name.split(" ")[0];
    },
  },
  components: {
    Hero,
  },
  async mounted() {
    this.isLoading = true;
    const returnTest = await this.$store.dispatch(
      'tests/returnTest',
      {
        user_id: this.$route.params.user_id,
        source_test_id: this.$route.params.source_test_id,
        opportunity_id: this.$route.params.opportunity_id,
      }
    );
    if (!returnTest || returnTest.error) {
      this.$swal(
        'Uoops',
        'Algo errado aconteceu. Tente novamente.',
        'error'
      );
    }
    this.$router.push(`/vagas/${this.$route.params.opportunity_id}/inscricao/testes`);
  },
  methods: {
  },
};
</script>

<style lang="scss"></style>